import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { navLinks } from '../data/site';
export function Footer() {
  return <footer className="border-t border-line bg-paper" data-id="element-36" data-mp="3ggkal1dq1o2p">
      <div className="mx-auto max-w-[1240px] px-6 py-16 md:px-10 md:py-20" data-id="element-37" data-mp="32onkt3zizq9h">
        <div className="grid gap-10 sm:grid-cols-2 md:grid-cols-12 md:gap-12" data-id="element-38" data-mp="36p6buvtlgsam">
          <div className="sm:col-span-2 md:col-span-6" data-id="element-39" data-mp="36n3c3k2n3ksp">
            <Logo size="lg" data-id="element-40" data-mp="3ugbsveb9tqmi" />
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-mist" data-id="element-41" data-mp="3ucxndx7b91au">
              An AI-native law firm combining technology with lawyer oversight.
            </p>
          </div>

          <nav aria-label="Footer" className="md:col-span-3" data-id="element-42" data-mp="3le2kov3h69ca">
            <p className="text-[12px] uppercase tracking-[0.16em] text-mist" data-id="element-43" data-mp="3qcds6z6as7rc">
              Navigate
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-44" data-mp="29ydrvn3jig3k">
              {navLinks.map(link => <li key={link.to} data-id="element-45" data-mp="2ezbeqczhvybe">
                  <Link to={link.to} className="text-[15px] text-graphite transition-colors hover:text-ink" data-id="element-46" data-mp="2ew70snw89o7j">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="md:col-span-3" data-id="element-47" data-mp="3v5n5kc18p9x2">
            <p className="text-[12px] uppercase tracking-[0.16em] text-mist" data-id="element-48" data-mp="3q83rpd8gez5n">
              Get in touch
            </p>
            <ul className="mt-4 space-y-2.5" data-id="element-49" data-mp="81yxik4n004i">
              <li data-id="element-50" data-mp="80nu4lf3sudx">
                <a href="mailto:hello@nexlaw.ca" className="text-[15px] text-graphite transition-colors hover:text-ink" data-id="element-51" data-mp="3472hh8p3xw3">
                  hello@nexlaw.ca
                </a>
              </li>
              <li data-id="element-52" data-mp="cu8uul8302gt">
                <Link to="/contact" className="text-[15px] text-graphite transition-colors hover:text-ink" data-id="element-53" data-mp="cvtn246xb9bi">
                  Contact form
                </Link>
              </li>
              <li className="text-[15px] text-mist" data-id="element-54" data-mp="tvcwfj28tpax">nexlaw.ca</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-line pt-6 text-[13px] text-mist md:flex-row md:items-center md:justify-between" data-id="element-55" data-mp="ytehuan560pk">
          <p data-id="element-56" data-mp="13rzfq3ex88au">© {new Date().getFullYear()} NexLaw. All rights reserved.</p>
          <p data-id="element-57" data-mp="18ksmewty9qpk">Currently focused on Ontario and Quebec.</p>
        </div>
      </div>
    </footer>;
}